import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ParentCategoryServices from './ParentCategoryServices';

const initialState = {
  loading: false,
  data: null,
  error: null,
  success: false,
};

export const getpublicParentCategoryMethod = createAsyncThunk(`/get-publicParentCategory`, async () => {
  try {
    const { data } = await ParentCategoryServices.publicGet();
    return data.data;
  } catch (error) {
    console.error('-------', error.message);
    throw error;
  }
});

const publicParentCatgroySlice = createSlice({
  name: 'publicParentCatgroy',
  initialState,
  reducers: {},
  extraReducers: {
    // get
    [getpublicParentCategoryMethod.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getpublicParentCategoryMethod.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.data = payload;
    },
    [getpublicParentCategoryMethod.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default publicParentCatgroySlice.reducer;
